import {getElementById, createElement, append, setId} from "@acng/frontend-bounty";
import {TAGNAME_TEMPLATE} from "@acng/frontend-bounty/dom/type.js";
import {IS, STRING, typeguard} from "@acng/frontend-bounty/typeguard.js";

const MODULE = "stargazer/find-or-create";

/**
 * @param {HTMLTemplateElement} resource
 * @param {string[]} path
 * @returns {HTMLTemplateElement}
 */
export const findOrCreate = (resource, path) => {
  for (const id of path) {
    let element = getElementById(id, resource.content);

    if (!element) {
      ASSERT: typeguard(`${MODULE} resource-id`, id, STRING);

      element = createElement(TAGNAME_TEMPLATE);
      setId(element, id);
      append(resource.content, element);
    }

    ASSERT: typeguard(`${MODULE} element`, element, IS(HTMLTemplateElement));

    resource = element;
  }

  return resource;
};
